import React, { FC } from 'react'
import { TabsWithControlComponent } from './TabsWithControl'
import { Wrapper, Title } from './styled'

export const AreYouRegisteredComponent: FC = () => (
	<Wrapper>
		<Title>Вы уже зарегистрированы как&nbsp;самозанятый?</Title>
		<TabsWithControlComponent />
	</Wrapper>
)
